import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Icon, Panel, PageHead, EmptyState, dateTimeET, etSyd } from "@/sentinel";

const when = (ts) => (ts ? `${dateTimeET(ts).slice(0, 10)} ${etSyd(ts)}` : "");

export default function Notifications() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data } = useQuery({ queryKey: ["pm-notifications"], queryFn: api.pmNotifications });
  const rows = data?.items || [];

  useEffect(() => {
    (async () => { await api.pmReadNotifications(); qc.invalidateQueries({ queryKey: ["pm-notifications"] }); })();
  }, []);

  return (
    <div className="sn-stack" style={{ gap: "var(--space-5)" }} data-testid="pm-notifications">
      <PageHead crumb={["Project", "Notifications"]} title="Notifications" context="Assignments, approvals and @mentions." />
      {rows.length === 0 ? (
        <EmptyState icon="BellRing" title="Nothing yet">Mention a teammate with @name in a comment or discussion.</EmptyState>
      ) : (
        <Panel title="Inbox" icon="BellRing" flush meta={<span className="sn-num">{rows.length}</span>}>
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {rows.map((n) => (
              <li key={n.id}>
                <button type="button" onClick={() => navigate(n.link || "/pm")} data-testid={`pm-notif-${n.id}`}
                  className="sn-row"
                  style={{
                    width: "100%", flexWrap: "nowrap", alignItems: "flex-start", gap: "var(--space-3)", padding: "var(--space-3) var(--space-4)",
                    textAlign: "left", cursor: "pointer", background: "transparent", border: 0, borderBottom: "1px solid var(--border-hairline)",
                    boxShadow: n.read ? undefined : "inset 3px 0 0 var(--unread)",
                  }}>
                  <Icon name="Bell" style={{ color: n.read ? "var(--text-tertiary)" : "var(--unread)", marginTop: 2, flex: "none" }} />
                  <span className="sn-stack" style={{ gap: "var(--space-1)", minWidth: 0 }}>
                    <span style={{ color: "var(--text-primary)" }}>
                      {!n.read && <span className="sn-vh">Unread: </span>}<b style={{ fontWeight: 600 }}>{n.actor}</b> {n.text}
                    </span>
                    <span className="sn-num sn-faint" style={{ fontSize: 12 }}>{when(n.created_at)}</span>
                  </span>
                  <Icon name="ChevronRight" size={14} style={{ color: "var(--text-tertiary)", marginLeft: "auto", marginTop: 3, flex: "none" }} />
                </button>
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
